import React from 'react';
import TextAdapter from './TextAdapter';
import { AdapterProps } from '../types';

const NumberAdapter = (props: AdapterProps['number']) => {
  const { max, ...rest } = props;

  return (
    <TextAdapter
      type="number"
      inputmode="numeric"
      max={max}
      onBeforeInput={(event: any) => {
        if (event.data && /[^0-9.\-]/.test(event.data)) {
          event.preventDefault();
          return;
        }
        if (max !== undefined) {
          const current = event.target.value ?? '';
          const next = parseFloat(current + event.data);
          if (!isNaN(next) && next > max) {
            event.preventDefault();
          }
        }
      }}
      {...rest}
    />
  );
};

export default NumberAdapter;
